import Swal from 'sweetalert2';
import $http from '../axios-instance';
import Vue from 'vue';
import store from "../store/store";
import axios from 'axios';
import {obtenerDominio} from "../util/dominios";
const vue = new Vue;

export async function attemptLogin(originalRequest) {


    let textAttempt = '';
    if (store.state.autenticacion.attempts > 0 ){
        textAttempt = `Intento ${store.state.autenticacion.attempts} de 3`
    }

    const emailState = store.state.autenticacion.email;
    let email = localStorage.getItem('email');
    if (!email){
        email = emailState;
    }

    store.commit("dashboard/load", false, { root: true });

    const { value: password } = await Swal.fire({
        title: 'Autenticación requerida',
        text: `Debido a que superado el tiempo de inactividad debe ingresar nuevamente su contraseña. ${textAttempt}`,
        html: `
            <div id="modal-resume-session" class="swal2-html-container" style="display: block;">Debido a que superado el tiempo de inactividad debe ingresar nuevamente su contraseña. ${textAttempt}</div>
            <p class="mt-3 mb-0"><i class="font-weight-bold">${email}</i></p>
            <div style="position: relative;">
                <input type="password" class="swal2-input" placeholder="Contraseña" autocomplete="current-password" name="password" id="password" />
                <i id="toggle-password" class="fa fa-eye-slash" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"></i>
            </div>
        `,
        preConfirm: () => {
            const inputPassword = document.getElementById('password').value;
            if (!inputPassword) {
                Swal.showValidationMessage('Por favor, ingrese su contraseña para poder continuar.');
            }
            return inputPassword;
        },
        onBeforeOpen: () => {

            const otherModals = document.querySelectorAll('.modal.show');
            otherModals.forEach(modal => modal.setAttribute('inert', ''));
            const togglePassword = document.getElementById('toggle-password');
            const passwordInput = document.getElementById('password');
            if (togglePassword && passwordInput) {
                togglePassword.addEventListener('click', () => {
                    const type = passwordInput.type === 'password' ? 'text' : 'password';
                    passwordInput.type = type;

                    if (type === 'password') {
                        togglePassword.classList.remove('el-icon-view');
                        togglePassword.classList.add('fa-eye-slash');
                    } else {
                        togglePassword.classList.remove('fa-eye-slash');
                        togglePassword.classList.add('el-icon-view');
                    }
                });
            }
        },
        onClose: () => {
            const otherModals = document.querySelectorAll('.modal.show');
            otherModals.forEach(modal => modal.removeAttribute('inert'));
        },
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: 'Reanudar sesión',
        cancelButtonText: 'Cerrar sesión',
        confirmButtonColor: "#3085d6",
        cancelButtonColor: '#d33',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        reverseButtons: true,
    });

    // Si el usuario proporcionó una contraseña
    if (password) {
        try {
            const axiosInstance = axios.create();
            const loginResponse = await axiosInstance.post(obtenerDominio() + "/auth/login", {email, password});
            if (loginResponse.status == 200){
                const newToken = "Bearer " + loginResponse.data.data.token;
                localStorage.setItem("token", newToken);
                localStorage.setItem("acl", JSON.stringify(loginResponse.data.data.acl));
                localStorage.setItem("cambio_clave", JSON.stringify(loginResponse.data.data.cambio_clave));
                $http.defaults.headers.common["Authorization"] = newToken;
                originalRequest.headers.Authorization = newToken;
                store.commit("autenticacion/resetAttempts", 0, { root: true });
                if (!store.state.autenticacion.originalRequest){
                    store.commit("autenticacion/setOriginalRequest", originalRequest, { root: true });
                }
                vue.$alertSuccess('La autenticación ha sido exitosa, puedes continuar utilizando Soluquim',5000);
                return Promise.resolve(originalRequest);
            }
        } catch (loginError) {
            store.commit("autenticacion/setAttempt", 1, { root: true });
            if (!store.state.autenticacion.originalRequest){
                store.commit("autenticacion/setOriginalRequest", originalRequest, { root: true });
            }
            // Limpiar el almacenamiento y redirigir al login
            if (store.state.autenticacion.attempts >= 3) {
                vue.$alertError(`Ha superado la cantidad maxima de intentos permitidos 3`, 5000);
                store.commit("autenticacion/changeCloseSession", true, { root: true });
                store.commit("autenticacion/resetAttempts", 0, { root: true });
                localStorage.clear();
                document.location.href = "#/login";
                return Promise.reject({response : {status: 401 ,message: 'Ha superado la cantidad maxima de intentos permitidos'}});
            }
        }
    } else {

     store.commit("autenticacion/changeCloseSession", true, { root: true });
      await  Swal.fire({
            title: 'Sesión finalizada',
            text: `Gracias por usar Soluquim`,
            icon: "success",
            allowOutsideClick: false,
        });
        localStorage.clear();
        document.location.href = '#/login';
        return Promise.reject({response : {status: 401 ,message: 'No token found in local storage'}});

    }
}
